import {
  ChatEventFragment,
  ConversationsV2UserMessageInput,
  SendUserMessageMutation,
  SendUserMessageMutationVariables,
  useSendUserMessageMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useSendUserMessage = withStandardMutationHook<
  SendUserMessageMutation,
  ChatEventFragment,
  SendUserMessageMutationVariables,
  'sendUserMessage',
  [string, ConversationsV2UserMessageInput, string?]
>(
  useSendUserMessageMutation,
  'sendUserMessage',
  (name, userMessage, chatEventId) => ({
    name,
    userMessage,
    chatEventId,
  }),
);
